'use client';

// Stores the SHA-256 hash of the traveller's PIN (matching the `pinHash`
// shipped by the manifest blocks) — not the raw PIN. The raw value never
// touches storage. Base64 encoding on key + value continues to obfuscate the
// sessionStorage view in dev-tools.
const PIN_STORAGE_PREFIX = 'pin-hash-';
const PIN_STORAGE: Storage | undefined =
  typeof window !== 'undefined' ? window.sessionStorage : undefined;

const encodeString = (str: string): string => {
  return btoa(str);
};

const decodeString = (encoded: string): string => {
  return atob(encoded);
};

export const getPersistedPinHash = (mpi: number): string | undefined => {
  const result = PIN_STORAGE?.getItem(encodeString(PIN_STORAGE_PREFIX + mpi));
  if (!result) return undefined;
  return decodeString(result);
};

export const setPersistedPinHash = (mpi: number, pinHash: string): void => {
  PIN_STORAGE?.setItem(
    encodeString(PIN_STORAGE_PREFIX + mpi),
    encodeString(pinHash),
  );
};
